const LockedIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="324"
      height="261"
      viewBox="0 0 324 261"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M71.9781 188.441L71.4411 188.751L70.9361 188.441L70.9391 187.854L69.6191 187.078L32.1501 208.711C24.0411 206.163 13.6851 206.863 6.82614 210.823C2.61814 213.252 0.540142 216.441 0.575142 219.625C0.580142 220.044 0.574142 221.779 0.575142 222.229C0.581142 225.381 2.66014 228.532 6.82614 230.937C15.1751 235.757 28.7101 235.757 37.0581 230.937C41.2421 228.521 43.3231 225.354 43.3101 222.188C43.3081 221.752 43.3091 219.995 43.3071 219.55C43.3041 218.642 43.1271 217.735 42.7821 216.844L48.8841 213.321V210.661L48.0141 209.379L50.4931 207.948L58.3961 207.829L60.4301 206.655L61.2071 203.706L65.0561 201.407L69.2091 201.587L73.8161 198.927V196.267V192.163V189.503L71.9781 188.441ZM11.7771 225.267C11.1931 224.93 10.7551 224.54 10.4591 224.124C10.7551 223.709 11.1921 223.319 11.7771 222.982C14.1421 221.616 17.9761 221.616 20.3411 222.982C20.9261 223.319 21.3631 223.709 21.6591 224.124C21.3631 224.539 20.9261 224.929 20.3411 225.267C17.9761 226.633 14.1411 226.633 11.7771 225.267Z"
        fill="#E0E0E0"
      />
      <path
        opacity="0.1"
        d="M43.2747 220.266V222.606C43.1128 225.623 41.0567 228.626 37.0527 230.939C34.4417 232.454 31.3037 233.482 27.9897 234.05V231.372C31.3037 230.817 34.4287 229.789 37.0527 228.274C40.9077 226.042 42.9907 223.188 43.2747 220.266Z"
        fill="black"
      />
      <path opacity="0.15" d="M33.9368 209.681L33.5278 209.45L70.9398 187.852" fill="black" />
      <path
        opacity="0.15"
        d="M50.4923 207.948V205.289L46.7173 207.468L48.0133 209.38L50.4923 207.948Z"
        fill="black"
      />
      <path
        opacity="0.1"
        d="M58.3957 205.164V207.823L50.4927 207.942V205.283L58.3957 205.164Z"
        fill="black"
      />
      <path
        opacity="0.1"
        d="M61.2082 201.047V203.707L60.4302 206.656V203.996L61.2082 201.047Z"
        fill="black"
      />
      <path
        opacity="0.15"
        d="M65.0565 201.402V198.742L61.2075 201.041V203.701L65.0565 201.402Z"
        fill="black"
      />
      <path
        opacity="0.1"
        d="M65.0571 198.742L69.2101 198.922V201.581L65.0571 201.402V198.742Z"
        fill="black"
      />
      <path
        d="M37.058 228.278C43.361 224.639 44.898 219.294 41.684 214.819L48.883 210.662L46.717 207.468L50.492 205.288L58.395 205.169L60.429 203.995L61.206 201.046L65.055 198.747L69.208 198.927L73.815 196.267V189.503L71.976 188.441L71.439 188.751L70.934 188.441L70.937 187.854L69.617 187.078L32.148 208.711C24.04 206.163 13.683 206.863 6.82399 210.823C-1.52401 215.643 -1.52401 223.458 6.82399 228.278C15.174 233.098 28.71 233.098 37.058 228.278ZM11.777 225.267C9.41198 223.902 9.41198 221.688 11.777 220.322C14.142 218.956 17.976 218.956 20.341 220.322C22.706 221.688 22.706 223.901 20.341 225.267C17.976 226.633 14.142 226.633 11.777 225.267Z"
        fill="#F0F0F0"
      />
      <g opacity="0.1">
        <path
          d="M21.9419 229.433C16.6579 229.433 11.7269 228.265 8.05495 226.147C4.85595 224.301 3.02295 221.895 3.02295 219.548C3.02295 217.202 4.85695 214.796 8.05495 212.95C11.7259 210.832 16.6579 209.664 21.9419 209.664C27.2259 209.664 32.1569 210.832 35.8289 212.95C39.028 214.796 40.861 217.2 40.861 219.548C40.861 221.897 39.0269 224.301 35.8289 226.147C32.1579 228.265 27.2259 229.433 21.9419 229.433ZM21.9419 210.432C16.7909 210.432 11.9949 211.562 8.43895 213.616C5.48495 215.321 3.79095 217.484 3.79095 219.548C3.79095 221.614 5.48495 223.776 8.43895 225.481C11.9939 227.534 16.7899 228.665 21.9419 228.665C27.0929 228.665 31.889 227.535 35.445 225.481C38.399 223.777 40.0929 221.613 40.0929 219.548C40.0929 217.482 38.399 215.32 35.445 213.616C31.89 211.562 27.0939 210.432 21.9419 210.432Z"
          fill="black"
        />
      </g>
      <path
        opacity="0.15"
        d="M70.9398 187.852L70.9358 188.439L71.4408 188.749L34.5648 210.037L33.5278 209.45L70.9398 187.852Z"
        fill="black"
      />
      <path opacity="0.15" d="M70.94 187.852L70.936 188.439L33.937 209.681" fill="black" />
      <path
        d="M245.816 200.652V203.347C245.805 206.514 247.892 209.683 252.077 212.1C258.38 215.739 267.637 216.627 275.389 214.771L282.589 218.927L288.121 217.677L291.896 219.857L292.102 224.42L294.136 225.594L299.244 226.043L302.915 228.091V230.663L307.522 233.323H319.237L323.436 230.9V228.18L285.967 209.267C287.693 207.436 288.558 205.406 288.562 203.377V200.653C287.999 198.023 285.807 196.666 282.309 194.646C273.961 189.826 260.425 189.826 252.077 194.646C248.324 196.813 246.195 197.819 245.816 200.652ZM257.292 197.504C259.657 196.138 263.491 196.138 265.856 197.504C268.221 198.869 268.221 201.083 265.856 202.448C263.491 203.814 259.657 203.814 257.292 202.448C254.927 201.083 254.927 198.869 257.292 197.504Z"
        fill="#E0E0E0"
      />
      <path
        d="M252.078 209.381C258.381 213.02 267.638 213.906 275.39 212.051L282.59 216.208L288.122 214.958L291.897 217.138L292.103 221.701L294.137 222.875L299.245 223.325L303.228 225.546L302.916 227.944L307.523 230.605H319.238L323.437 228.181L285.968 206.549C290.381 201.867 289.17 195.888 282.31 191.928C273.962 187.108 260.426 187.108 252.078 191.928C243.729 196.746 243.729 204.561 252.078 209.381ZM257.292 194.783C259.657 193.418 263.491 193.418 265.856 194.783C268.221 196.148 268.221 198.362 265.856 199.728C263.491 201.093 259.657 201.093 257.292 199.728C254.927 198.363 254.927 196.149 257.292 194.783Z"
        fill="#F0F0F0"
      />
      <g opacity="0.1">
        <path
          d="M253.307 207.255C250.108 205.407 248.274 203.003 248.274 200.656C248.274 198.308 250.108 195.904 253.307 194.057C256.977 191.939 261.909 190.773 267.194 190.773C272.479 190.773 277.411 191.939 281.081 194.057C284.28 195.904 286.113 198.31 286.113 200.656C286.113 203.002 284.279 205.408 281.081 207.255C277.41 209.373 272.478 210.539 267.194 210.539C261.91 210.54 256.979 209.373 253.307 207.255ZM253.691 194.722C250.737 196.427 249.043 198.59 249.043 200.655C249.043 202.721 250.737 204.883 253.691 206.588C257.248 208.64 262.042 209.77 267.193 209.77C272.344 209.77 277.139 208.64 280.696 206.588C283.65 204.881 285.344 202.719 285.344 200.655C285.344 198.591 283.65 196.428 280.696 194.722C277.142 192.67 272.346 191.54 267.193 191.54C262.041 191.54 257.245 192.671 253.691 194.722Z"
          fill="black"
        />
      </g>
      <path
        opacity="0.1"
        d="M259.5 212.161V214.88C264.607 216.017 270.319 215.979 275.389 214.766V212.047C270.32 213.26 264.607 213.298 259.5 212.161Z"
        fill="black"
      />
      <path
        opacity="0.1"
        d="M282.589 216.211V218.931L288.121 217.681V214.961L282.589 216.211Z"
        fill="black"
      />
      <path
        opacity="0.1"
        d="M291.896 217.133V219.854L292.102 224.417V221.696L291.896 217.133Z"
        fill="black"
      />
      <path
        opacity="0.1"
        d="M294.136 222.875V225.596L299.244 226.045V223.324L294.136 222.875Z"
        fill="black"
      />
      <path opacity="0.1" d="M319.237 230.602H307.522V233.323H319.237V230.602Z" fill="black" />
      <path
        opacity="0.15"
        d="M323.437 228.18V230.901L319.237 233.324V230.603L321.078 229.541V230.715L322.093 230.129V228.942L323.437 228.18Z"
        fill="black"
      />
      <path d="M322.093 228.945L321.078 229.544V230.718L322.093 230.132V228.945Z" fill="#BA68C8" />
      <path
        opacity="0.15"
        d="M322.092 228.943V230.13L283.667 207.942L284.683 207.344L322.092 228.943Z"
        fill="black"
      />
      <path
        opacity="0.15"
        d="M284.683 207.344V208.53L283.667 207.942L284.683 207.344Z"
        fill="black"
      />
      <path
        d="M161.592 260.694C200.027 260.694 231.184 242.705 231.184 220.515C231.184 198.325 200.027 180.336 161.592 180.336C123.158 180.336 92.0005 198.325 92.0005 220.515C92.0005 242.705 123.158 260.694 161.592 260.694Z"
        fill="#4B4B4B"
        fill-opacity="0.05"
      />
      <path
        d="M102.001 72.3141C102.001 70.0331 103.508 67.7511 106.523 66.0101L115.414 60.8771C121.444 57.3951 131.221 57.3951 137.251 60.8771L217.84 107.406C220.858 109.149 222.365 111.434 222.361 113.718L222.36 220.157C222.367 222.444 220.861 224.732 217.839 226.477L208.951 231.609C202.921 235.091 193.144 235.091 187.113 231.609L106.522 185.08C103.507 183.339 102 181.058 102 178.777V72.3141H102.001Z"
        fill="#737373"
      />
      <path
        opacity="0.4"
        d="M102.001 72.3141C102.001 70.0331 103.508 67.7511 106.523 66.0101L115.414 60.8771C121.444 57.3951 131.221 57.3951 137.251 60.8771L217.84 107.406C220.858 109.149 222.365 111.434 222.361 113.718L222.36 220.157C222.367 222.444 220.861 224.732 217.839 226.477L208.951 231.609C202.921 235.091 193.144 235.091 187.113 231.609L106.522 185.08C103.507 183.339 102 181.058 102 178.777V72.3141H102.001Z"
        fill="white"
      />
      <path
        opacity="0.4"
        d="M208.953 125.146L217.841 120.014C223.871 116.532 223.871 110.887 217.841 107.406L137.252 60.8771C131.222 57.3951 121.445 57.3951 115.414 60.8771L106.523 66.0101C100.493 69.4921 100.493 75.1361 106.523 78.6181L187.114 125.147C193.146 128.628 202.923 128.628 208.953 125.146Z"
        fill="white"
      />
      <path
        opacity="0.3"
        d="M198.022 127.756V234.219C201.981 234.219 205.94 233.362 208.941 231.622L217.842 226.478C220.868 224.738 222.381 222.443 222.356 220.149V113.711C222.356 116.006 220.868 118.275 217.842 120.015L208.941 125.159C205.94 126.899 201.982 127.756 198.022 127.756Z"
        fill="#F2F2F2"
      />
      <path
        d="M139.376 180.416L158.618 191.526L155.637 156.717C157.938 155.5 159.405 152.506 159.405 148.206C159.405 140.542 154.745 131.638 148.996 128.319C143.249 125.001 138.589 128.524 138.589 136.189C138.589 140.488 140.056 145.177 142.357 149.051L139.376 180.416Z"
        fill="#737373"
      />
      <path d="M139.376 180.415L156.805 170.352L158.618 191.525L139.376 180.415Z" fill="#4B4B4B" />
      <path
        d="M148.996 128.319C152.757 130.491 156.043 135.056 157.872 140.098L142.357 149.056L142.358 149.051C140.056 145.177 138.59 140.488 138.59 136.189C138.589 128.524 143.249 125.001 148.996 128.319Z"
        fill="#4B4B4B"
      />
      <path
        d="M123.779 74.6888C123.779 74.6848 123.777 74.6798 123.777 74.6748H123.779V32.1118C123.779 18.9288 128.761 8.49179 137.448 3.47679C145.739 -1.31021 155.992 -0.661201 166.323 5.3018C185.296 16.2558 200.159 42.9858 200.159 66.1528V108.95H200.161C200.161 110.236 199.303 111.521 197.604 112.502C194.206 114.464 188.695 114.464 185.297 112.502C183.598 111.521 182.74 110.235 182.74 108.95H182.741V66.1528C182.741 49.2088 171.234 28.2508 157.615 20.3868C152.971 17.7058 148.797 17.0398 146.159 18.5608C143.053 20.3538 141.199 25.4198 141.199 32.1118V74.6748H141.2C141.2 74.6768 141.199 74.6788 141.199 74.6808V74.7048H141.195C141.181 75.9808 140.329 77.2538 138.643 78.2268C135.245 80.1888 129.734 80.1898 126.336 78.2268C124.65 77.2538 123.797 75.9798 123.784 74.7048H123.781V74.6888H123.779Z"
        fill="#737373"
      />
    </svg>
  );
};

export default LockedIcon;
